var now = new Date(); //当前日期 
var nowDayOfWeek = now.getDay(); //今天本周的第几天 
var nowDay = now.getDate(); //当前日 
var nowMonth = now.getMonth(); //当前月 
var nowYear = now.getYear(); //当前年 
nowYear += (nowYear < 2000) ? 1900 : 0; //

var lastMonthDate = new Date(); //上月日期
lastMonthDate.setDate(1);
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
var lastYear = lastMonthDate.getYear();
var lastMonth = lastMonthDate.getMonth();

// 函数防抖
export function debounce(fn, wait) {
    let timeout = null;
    wait = wait || 600;
    return function () {
        let that = this;
        if (timeout !== null) clearTimeout(timeout);
        timeout = setTimeout(() => {
            fn.apply(that);
        }, wait);
    }
}
//格式化日期：yyyy-MM-dd 
export function formatDate(date) {
    var myyear = date.getFullYear();
    var mymonth = date.getMonth() + 1;
    var myweekday = date.getDate();

    if (mymonth < 10) {
        mymonth = "0" + mymonth;
    }
    if (myweekday < 10) {
        myweekday = "0" + myweekday;
    }
    return (myyear + "-" + mymonth + "-" + myweekday);
}
//获得本周的开始日期 
export function getWeekStartDate() {
    console.log(nowDay, 'nowDay')
    var weekStartDate = new Date(nowYear, nowMonth, nowDay);
    return formatDate(weekStartDate);
}

//获得本周的结束日期 
export function getWeekEndDate() {
    var weekEndDate = new Date(nowYear, nowMonth, nowDay + 6);
    return formatDate(weekEndDate);
}
//获得本周周五的结束日期 
export function getWeekEndDateFive() {
    var weekEndDate = new Date(nowYear, nowMonth, nowDay + 6);
    return formatDate(weekEndDate);
}
//获得本月的开始日期
export function getMonthStartDate() {
    var monthStartDate = new Date(nowYear, nowMonth, 1);
    return formatDate(monthStartDate);
}

//获得本月的结束日期
export function getMonthEndDate() {

    var monthEndDate = new Date(
        nowYear,
        nowMonth,
        getMonthDays(nowMonth)
    );
    return formatDate(monthEndDate);
}
export function getMonthDays(myMonth) {
    var monthStartDate = new Date(nowYear, myMonth, 1);
    var monthEndDate = new Date(nowYear, myMonth + 1, 1);
    var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
    return days;
}